const AlertOrangeGradient = () => (
  <div
    className="flex-shrink-0 opacity-40 absolute"
    style={{
      height: '295px',
      width: '324px',
      left: '-10px',
      top: '-106px',
      background: 'radial-gradient(50% 50% at 50% 50%, #BF2525 0%, rgba(255, 212, 128, 0.00) 100%)',
    }}
  />
);

const AlertRedGradient = () => (
  <div
    className="flex-shrink-0 opacity-40 absolute"
    style={{
      height: '266px',
      width: '374px',
      right: '-64px',
      top: '-141px',
      transform: 'rotate(-13deg)',
      background: 'radial-gradient(50% 50% at 50% 50%, #F702A4 0%, rgba(225, 54, 116, 0.00) 100%)',
    }}
  />
);

export const AlertErrorGradient = () => (
  <div
    className="opacity-50 absolute w-full z-0 top-0 pointer-events-none"
    style={{
      maskImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 31.47%)',
    }}
  >
    <AlertOrangeGradient />
    <AlertRedGradient />
  </div>
);

const AlertGreenGradient = () => (
  <div
    className="flex-shrink-0 opacity-40 absolute"
    style={{
      height: '295px',
      width: '324px',
      left: '-10px',
      top: '-106px',
      background: 'radial-gradient(50% 50% at 50% 50%, #3EBE6A 0%, rgba(62, 190, 106, 0.00) 100%)',
    }}
  />
);

const AlertTealGradient = () => (
  <div
    className="flex-shrink-0 opacity-40 absolute"
    style={{
      height: '266px',
      width: '374px',
      right: '-64px',
      top: '-141px',
      transform: 'rotate(-13deg)',
      background: 'radial-gradient(50% 50% at 50% 50%, #02F7B2 0%, rgba(54, 225, 165, 0.00) 100%)',
    }}
  />
);

export const AlertSuccessGradient = () => (
  <div
    className="opacity-50 absolute w-full z-0 top-0 pointer-events-none"
    style={{
      maskImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 31.47%)',
    }}
  >
    <AlertGreenGradient />
    <AlertTealGradient />
  </div>
);
